var React = require('react');

function TwitterBrandsIconBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.355,51.321c.01.142.01.284.01.426a9.266,9.266,0,0,1-9.33,9.33A9.267,9.267,0,0,1,0,59.6a6.784,6.784,0,0,0,.792.041,6.567,6.567,0,0,0,4.071-1.4A3.285,3.285,0,0,1,1.8,55.97a4.135,4.135,0,0,0,.619.051,3.468,3.468,0,0,0,.863-.112A3.28,3.28,0,0,1,.65,52.691v-.041a3.3,3.3,0,0,0,1.482.416,3.284,3.284,0,0,1-1.015-4.386,9.321,9.321,0,0,0,6.761,3.431,3.7,3.7,0,0,1-.081-.751,3.282,3.282,0,0,1,5.675-2.244,6.456,6.456,0,0,0,2.081-.792,3.27,3.27,0,0,1-1.442,1.807A6.574,6.574,0,0,0,16,49.625a7.049,7.049,0,0,1-1.645,1.7Z","transform":"translate(0 -48.082)","fill":"#4db2ec"}));
}

TwitterBrandsIconBlue.defaultProps = {"width":"16","height":"12.995","viewBox":"0 0 16 12.995"};

module.exports = TwitterBrandsIconBlue;

TwitterBrandsIconBlue.default = TwitterBrandsIconBlue;
